document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector(".tab-container");
  if (!container) return;
  const tabButtons = container.querySelectorAll(".tab-button");
  const tabPanels = container.querySelectorAll(".tab-panel");
  container.querySelector(".tab-buttons").addEventListener("click", event => {
    if (event.target.classList.contains("tab-button")) {
      const targetTab = event.target.getAttribute("data-tab");
      tabButtons.forEach(btn => btn.classList.remove("active"));
      tabPanels.forEach(panel => panel.classList.remove("active"));
      event.target.classList.add("active");
      container.querySelector(`.tab-panel[data-tab="${targetTab}"]`).classList.add("active");
    }
  });
  tabButtons[0].classList.add("active");
  tabPanels[0].classList.add("active");
});
document.querySelectorAll('.tab-button').forEach((button) => {
  button.addEventListener('click', (event) => {
    const container = document.querySelector('.tab-buttons-slider');
    const buttonRect = event.target.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    const offset = buttonRect.left - containerRect.left - (containerRect.width / 2) + (buttonRect.width / 2);
    container.scrollBy({
      left: offset,
      behavior: 'smooth' 
    });
  });
});


const reviewSwiperEl = document.querySelector('.reviews-slider');
if (reviewSwiperEl) {
  new Swiper('.reviews-slider', {
    centeredSlides: true,
    centerInsufficientSlides: true,
    loop: true,
    // loopAdditionalSlides: 6,     // 防止 loop 下复制数量不足导致的位移
    roundLengths: true,          // 解决移动端亚像素导致的“看起来不居中”
    watchOverflow: true,
    slidesPerGroup: 1,
    spaceBetween: 12,            // 用这个来控制间距，不要给 slide 加 margin
    breakpoints: {
      0: {
        slidesPerView: 1.2,
        centeredSlides: true
      },
      480: {
        slidesPerView: 1.5,
        centeredSlides: true
      },
      1000: {
        slidesPerView: 1.5
      },
      1400: {
        slidesPerView: 2
      },
      1800: {
        slidesPerView: 2.5
      },
      2200: {
        slidesPerView: 3
      }
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}
